import { css } from "@emotion/css"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import CouponShare from "./CouponShare/CouponShare"
import LinkBanners from "./LinkBanners/LinkBanners"
import ReferFriendsCouponBanner from "./ReferFriendsCouponBanner/ReferFriendsCouponBanner"
import SideBarNav from "./SideBarNav/SideBarNav"
import UserInfo from "./UserInfo/UserInfo"

const SideBar = () => {
  return (
    <aside className={style}>
      <SideBarNav />
      <Spacer size={10} />
      <UserInfo />
      <Spacer size={10} />
      <LinkBanners />
      <Spacer size={20} />
      <CouponShare />
      <Spacer size={10} />
      <ReferFriendsCouponBanner />
    </aside>
  )
}

export default SideBar

const style = css`
  width: 200px;
`
